import React, {useEffect, useState, useRef, useCallback} from 'react';

import Close from "../assets/Close.svg"
import styled, {css} from 'styled-components/macro'
import {AnimatePresence, motion} from "framer-motion";
import Spinner from "./Spinner";
import {useWeb3React} from "@web3-react/core";

import LoanPool from '../artifacts/src/contracts/LoanPool.sol/LoanPool';
import ERC20Token from '../artifacts/src/contracts/test/ERC20Token.sol/ERC20Token'

const LiquidateButton = styled(motion.button)`    
    width: 25%;
    min-width: 55px;
    height: 30px;
    margin-top: 5px;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    
    border: 1px solid #FAAD16;
    box-sizing: border-box;
    border-radius: 41px;
    background: transparent;
    color: #FAAD16;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 180%;
    
    cursor: pointer;
`


const Popup = styled(motion.div)`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);
    text-align: center;
    z-index: 3;
`

const PopupInner = styled(motion.div)`
    text-align: left;
    vertical-align: middle;
    position: absolute;
    max-width: 700px;
    width: 671px;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    z-index: 4;
    
    background: #FFFFFF;
    box-shadow: 0px 8px 36px rgba(0, 0, 0, 0.16);
    border-radius: 16px;
    
    text-align: center;


`

const PopupHeader = styled.div`
    width: 100%;
    height: 24px;
    font-size: 19px;
    left: calc(50% - 623px/2);
    top: calc(50% - 24px/2 - 10px);
    line-height: 24px;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-transform: capitalize;
`

const CloseButton = styled.a`
    width: 24px;
    margin-left: auto;
    height: 24px;
    cursor: pointer;
`

const ContentArea = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 40px;    
`

const InputBoxContainer = styled.div`
    position: static;
    height: auto;
    top: 8px;
    margin-bottom: 20px;
`
const InputBoxLabel = styled.div`
    display: flex;
    flex-direction:row;
    align-items: center;
    padding-left: 5px;
    
    white-space: nowrap;
    position: relative;
    height: 20px;
    width: ${props => props.FixedWidth || "10%"}};
    left: 30px;
    top: 10px;
    font-weight: bold;
    
    background: #FFFFFF;
`

const Required = styled.div`
    font-size: 11px;
    line-height: 16px;

    color: #DA1414;

    opacity: 0.8;
`

const InputBox = styled.input`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 0px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
`

const PopupFooter = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 40px;

`

const PopupButton = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    
    
    position: relative;
    width: 300px;
    height: 42px;
    margin: 15px;
    background: transparent;
    color: #FAC44E;
    border: 2px solid #FAC44E;

    border-radius: 30px;
    ${props => props.primary && css`
        background: #FAC44E;
        color: white;
    `}
    
    cursor: pointer;
`

const SelectBox = styled.select`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
    padding: 14px 15px;
    
    position: static;
    width: 95%;
    height: 48px;
    left: 0px;
    top: 0px;
    
    font-size: 16px;
    
    background: #FFFFFF;

    border: 1px solid #858C94;
    box-sizing: border-box;
    border-radius: 8px;
    
    option {
        color: black;
        background: white;
        display: flex;
        white-space: pre;
        min-height: 35px;
        
        padding: 14px 15px;

  }
`

const NotificationBox = styled.div`
    background: rgba(250, 173, 22, 0.1);
    border-radius: 6px;
    
    display: flex;
    flex-direction: column;
    align-items: flex-start;
   text-align: left;

    padding: 15px 16px;
`

const modalVariant = {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0 }
};
const containerVariant = {
    initial: { top: "-50%", transition: { type: "spring" } },
    isOpen: { top: "50%" },
    exit: { top: "-50%" }
};

const LiquidateLandModal = (props) => {
    const [modal, setModal] = useState(false);
    const [developerID, setDeveloperID] = useState();
    const [landList, setLandList] = useState([]);
    const [landID, setLandID] = useState();
    const [collateral, setCollateral] = useState();
    const [walletBalance, setWalletBalance] = useState();
    const [loanEntityDropdownList, setLoanEntityDropDownList] = useState([]);
    const [selectedLoanEntityID, setSelectedLoanEntityID] = useState();
    const [selectedLoanEntity, setSelectedLoanEntity] = useState();
    const [paymentAmount, setPaymentAmount] = useState();
    const web3Context = useWeb3React();

    const [loading, setLoading] = useState(false);

    const toggle = () => {
        if(props.developerInfos !== [] && typeof props.developerInfos !== "undefined" && props.developerInfos !== null && props.developerInfos.length !== null) {
            try {
                setDeveloperID(props.developerInfos[0].developerID)
            }
            catch(e) {
                window.location.reload();
            };
        }
        setLoading(false);
        setModal(!modal);
    };


    const loadLandList = useCallback((developerID) => {
        setCollateral();
        setLoanEntityDropDownList([]);
        setSelectedLoanEntity();
        setSelectedLoanEntityID(0);

        const selectedDeveloper = props.developerInfos.find(e => developerID === e.developerID);
        if (selectedDeveloper !== undefined) {
            setLandList(selectedDeveloper.landInfo);
            if(selectedDeveloper.landInfo.length > 0) {
                setLandID(selectedDeveloper.landInfo[0].landID);
            }
        }
    }, [developerID]);

    useEffect(() => {
        const selectedLand = landList.find(e => landID === e.landID);
        if(selectedLand !== undefined) {
            setCollateral(selectedLand);
        }
    }, [landID]);

    useEffect(() => {
        if (props.developerInfos !== undefined && props.developerInfos.length !== 0 && developerID === 0) {
            setDeveloperID(props.developerInfos[0].developerID);
        }

        if (developerID !== 0) {
            loadLandList(developerID);
        }
    },[developerID]);

    useEffect(() => {
        if(landID !== 0) {
            loadCollateral(landID);
        }
    }, [landID]);

    const loadCollateral = useCallback((landId) => {
        if(landId !== 0) {
            const selectedLand = landList.find(e => e.landID.toString() === landId.toString());
            if(selectedLand !== undefined) {
                setCollateral(selectedLand);
                loadLoanEntityList(landId);
            }
        }
    }, [landID]);

    const loadLoanEntityList = useCallback(async (landId) => {
        const ethLibrary = web3Context.library.eth;
        const loanPoolContract = new ethLibrary.Contract(
            LoanPool.abi,
            props.loanPool.loanPoolAddress
        );

        const loanEntityIDs = await loanPoolContract.methods
            .callgetLoanEntityIDsByLandID(landId)
            .call();

        const totalLoanEntityID = loanEntityIDs.length;
        let loanEntityArray = [];
        let loanEntityInfos = [];
        let loanEntityObject = {};
        for(var i = 1; i < totalLoanEntityID; i++) {
            loanEntityInfos = await loanPoolContract.methods.getLoanEntityPaymentInfoByLoanEntityID(loanEntityIDs[i]).call();
            loanEntityObject = {
                loanEntityID: loanEntityIDs[i],
                principal: loanEntityInfos[0] / props.loanPool.currencyBase,
                interestObligated: loanEntityInfos[1] / props.loanPool.currencyBase,
                totalPaid: loanEntityInfos[2] / props.loanPool.currencyBase
            };

            loanEntityArray.push(loanEntityObject);
        }
        setLoanEntityDropDownList(loanEntityArray);
        console.log(loanEntityArray);
        if(loanEntityArray.length > 0) {
            setSelectedLoanEntityID(loanEntityArray[0].loanEntityID);
            setSelectedLoanEntity(loanEntityArray[0]);
        }
    }, [web3Context]);

    const loadSelectedLoanEntity = useCallback((loanEntityId) => {
        const selectedLoanEntity = loanEntityDropdownList.find(e => e.loanEntityID === loanEntityId);
        if(selectedLoanEntity !== undefined) {
            setSelectedLoanEntity(selectedLoanEntity);
        }
    }, [selectedLoanEntityID]);


    useEffect(async() => {
        const ethLibrary = web3Context.library.eth;
        const stableTokenContract = new ethLibrary.Contract(
            ERC20Token.abi,
            props.loanPool.currency
        );

        const myAssetAmount = await stableTokenContract.methods
            .balanceOf(process.env.REACT_APP_MCADMIN_ADDRESS)
            .call();

        setWalletBalance(myAssetAmount / props.loanPool.currencyBase);
    });

    return (
        <AnimatePresence>
            <LiquidateButton
                key={"liquidateLandButton"}
                onClick={toggle}
                whileHover={{scale: 1.1}}
                whileTap={{scale: 0.9}}>
                LIQUIDATE
            </LiquidateButton>
            {
                modal && (
                    <Popup
                        key={"popup-payLoan"}
                        initial={"initial"}
                        animate={"isOpen"}
                        exit={"exit"}
                        variants={modalVariant}
                    >
                        <PopupInner
                            key={"popupInner-payLoan"}
                            variants={containerVariant}>
                            <PopupHeader>
                                Collateral Liquidation
                                <CloseButton onClick={toggle}><img src={Close}/></CloseButton>
                            </PopupHeader>
                            { loading ? (<Spinner/>): (
                                <ContentArea>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"19%"}>Select Developer<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setDeveloperID(e.target.value);
                                        }} required>
                                            {props.developerInfos.map((developer, index) => {
                                                return (<option value={developer.developerID} selected={developerID === developer.developerID} key={index}>{developer.companyName.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"19%"}>Select Collateral<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setLandID(e.target.value);
                                        }} required>
                                            {landList.map((land, index) => {
                                                return (<option value={land.landID} selected={landID === land.landID} key={index}>{land.propertyIdentificationNumber.toString() + " - " + land.propertyAddress.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"13%"}>Select Loan<Required>*</Required></InputBoxLabel>
                                        <SelectBox onChange= {e => {
                                            setSelectedLoanEntityID(e.target.value);
                                            loadSelectedLoanEntity(e.target.value);
                                        }} required>
                                            {loanEntityDropdownList.map((loanEntity, index) => {
                                                return (<option value={loanEntity.loanEntityID} key={index}>{"Loan Entity # " + loanEntity.loanEntityID.toString() + ", Remaining Balance $" + loanEntity.principal.toString()}</option>)
                                            })}
                                        </SelectBox>
                                    </InputBoxContainer>
                                    <NotificationBox>
                                        {
                                            selectedLoanEntity === undefined ? "" : (
                                                <div>Loan #{selectedLoanEntity.loanEntityID} remaining balance is ${selectedLoanEntity.principal}
                                                    <br/>Unpaid Interest is ${selectedLoanEntity.interestObligated}
                                                    <br/>Total debt obligation is ${(selectedLoanEntity.principal + selectedLoanEntity.interestObligated)}
                                                    <br/>Your MC wallet has ${walletBalance}
                                                </div>
                                            )
                                        }
                                    </NotificationBox>
                                    <InputBoxContainer>
                                        <InputBoxLabel FixedWidth={"20%"}>Liquidate Amount<Required>*</Required></InputBoxLabel>
                                        <InputBox
                                            type="number"
                                            onChange= {e => setPaymentAmount(e.target.value)}
                                            required/>
                                    </InputBoxContainer>
                                </ContentArea>
                            )}
                            <PopupFooter>
                                <PopupButton onClick={toggle}>Cancel</PopupButton>
                                <PopupButton onClick={() => {
                                    if(props.loanPool.currency !== undefined && paymentAmount !== undefined && props.loanPool.loanPoolID !== undefined && selectedLoanEntity !== undefined) {
                                        setLoading(true);
                                        props.action(paymentAmount, props.loanPool.loanPoolID, selectedLoanEntity.loanEntityID).catch(()=>{
                                            setLoading(false);
                                        })
                                    }
                                }}primary>Pay Loan</PopupButton>
                            </PopupFooter>
                        </PopupInner>
                    </Popup>
                )

            }
        </AnimatePresence>
    );
};

export default LiquidateLandModal;
